import { Button, Text, Box, Input } from "@chakra-ui/react";
import WithAuth from "../components/hoc/with-auth";
import { AuthLayout } from "../components/layouts/index";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index";
import DepositsAndWithdrawalsPage from "../components/pages/deposits-and-withdrawal-page";

const DepositsAndWithdrawals = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Deposits & Withdrawals List"
          pageDesc="List of all Deposits & Withdrawals"
        >
          <DepositsAndWithdrawalsPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default DepositsAndWithdrawals;
